export default class Panel {
  constructor(wattsPerPanel, actualCostPerPanel) {
    this.wattsPerPanel = wattsPerPanel;
    this.actualCostPerPanel = actualCostPerPanel;
  }
  cost() {
    this.wattsPerPanel * 1.5;
  }
}
